module.exports = __webpack_public_path__ + "img/kda.0cbc523b.png";